//

function filterByGradeIds(subjects, { ids, inclusive = true }) {
  return subjects.filter(
    (subject) => inclusive === subject.grades.some((grade) => ids.includes(grade.id))
  );
}

function getGradeIdFilter({ ids, inclusive = true }) {
  return (subjects) => filterByGradeIds(subjects, { ids, inclusive });
}

// Exports
// -------

export { getGradeIdFilter, filterByGradeIds };
